import { InputCheckboxGroup, ReviewTextListField, useFormContext } from '@goodfynd/forms';
import { FlexColumn, FlexColumns } from '@goodfynd/ui';

import type { NewslettersFields, StepNewslettersProps } from './types';

export function StepNewsletters({ newsletterOptions }: StepNewslettersProps) {
  const { control } = useFormContext<NewslettersFields>();

  return (
    <>
      <InputCheckboxGroup
        control={control}
        label="Newsletters"
        name="newsletters"
        options={newsletterOptions}
      />
    </>
  );
}

export function StepNewslettersSummary({
  newsletterOptions,
}: StepNewslettersProps) {
  const { getValues } = useFormContext<NewslettersFields>();
  const { newsletters = [] } = getValues();
  return (
    <FlexColumns columns={2} gap={16} span="stretch" wrap="nowrap">
      <FlexColumn gap={16} size={1} wrap="nowrap">
        <ReviewTextListField
          label="Subscriptions"
          values={newsletters.map(
            (newsletter) =>
              newsletterOptions.find(
                (option) => Number(option.value) === newsletter
              )?.label ?? 'Unknown'
          )}
        />
      </FlexColumn>
    </FlexColumns>
  );
}
